import {ShapeCommand} from '../commands.template';

export class ActivityAddUrlRecordCommand extends ShapeCommand {
  services: any;
  mxKey: number;
  mxKeys: number[];
  constructor(data) {
    super(data);
  }

  public execute() {
    let itemMxKey = this.getMxKey(this.object.itemMxKey);

    const attachments = this.object.records.map(item => {
      return {
        mxKey: itemMxKey++,
        type: item.type,
        itemMxKey: this.object.itemMxKey,
        groups: item.groups,
        title: item.title,
        value: item.value,
        description: item.description,
        tags: item.tags,
        urlEntry: item.urlEntry,
        position: item.position
      };
    });

    this.mxKeys = attachments.map(a => a.mxKey);
    const action = {
      createUrlRecordsAttachments: attachments
    };

    return this.services.diagramUpdateSvc.update(action, true, true).then(result => {
      this.services.jsonHandlerSvc.update(action);
      this.redrawActivity(this.object.itemMxKey);

      return result;
    });
  }

  public reverse() {
    const action = {
      deleteUrlRecordsAttachments: {
        itemMxKey: this.object.itemMxKey,
        mxKeys: this.mxKeys
      }
    };

    return this.services.diagramUpdateSvc.update(action).then(result => {
      this.redrawActivity(this.object.itemMxKey);

      return result;
    });
  }

  private getMxKey(itemMxKey) {
    const activity = this.services.jsonHandlerSvc.get().activities.find(a => {
      return Number(a.mxKey) === Number(itemMxKey);
    });

    if (!activity['attachments']) {
      activity['attachments'] = [];
    }

    // generate new mxKey
    let mxKey = 0;

    activity['attachments'].forEach(function (attachment) {
      if (attachment.mxKey > mxKey) {
        mxKey = attachment.mxKey;
      }
    });

    return mxKey + 1;
  }

  private redrawActivity(mxKey) {
    this.services.editorRegistrySvc
      .getGraph()
      .model.getCell(Number(mxKey))
      .comp.instance.setupFromJson();
  }
}
